module.exports = __webpack_public_path__ + "officialStatic/img/auth3.e1194ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/auth3.jpg
// module id = B48l
// module chunks = 0